import { Provider } from '@angular/core';
import { SENTENCE_CASE_DICTIONARY, SentenceCaseDictionary } from '@panaya/ui/pipes';

const sentenceCaseDictionary: SentenceCaseDictionary = {
    PHRASE_WITH_SPACES: {
        'quick test': 'quicktest'
    },
    WORDS_TO_UPPERCASE: {
        sap: 'SAP',
        id: 'ID',
        salesforce: 'Salesforce',
        oracle: 'Oracle',
        quicktest: 'Quick Test',
        quicktests: 'Quick Tests',
        ok: 'OK',
        db: 'DB',
        dw: 'DW',
        hana: 'HANA',
        abap: 'ABAP',
        atc: 'ATC',
        si: 'SI',
        sci: 'SCI',
        sp: 'SP',
        sps: 'SPS',
        ehp: 'EHP',
        z_unused: 'Z_UNUSED',
        etl: 'ETL',
        's/4': 'S/4',
        bw: 'BW',
        qa: 'QA',
        rnd: 'RnD',
        'r&d': 'R&D',
        bi: 'BI',
        di: 'DI',
        badi: 'BAdI',
        bapi: 'BAPI',
        sql: 'SQL',
        adbc: 'ADBC',
        ux: 'UX',
        rdx: 'RDX',
        sf: 'SF',
        it: 'IT',
        jira: 'Jira',
        worksoft: 'Worksoft'
    },
    MULTIPLE_WORDS_TO_UPPERCASE: {
        ['fix package']: 'Fix Package',
        ['fix packages']: 'Fix Packages',
        ['s/4 hana']: 'S/4 HANA'
    }
};

export const sentenceCaseDictionaryProvider: Provider = {
    provide: SENTENCE_CASE_DICTIONARY,
    useValue: sentenceCaseDictionary
};
